import React, { useEffect } from 'react';
import { Form } from 'antd';
import { useAuth } from '../../../contexts/userContext/userContext';
import PhysicalCustomerBookingInfo from './components/PhysicalCustomerBookingInfo';
import LegalCustomerBookingInfo from './components/LegalCustomerBookingInfo';
import PersonInfo from './components/PersonInfo';
import { useBooking } from '../../../contexts/ticketBookingContext/TicketBookingContext';
import CustomerCheckInput from '../../inputs/customerCheckInput/CustomerCheckInput';
import useTranslation from '../../../hooks/translation/useTranslation';
import CustomerTextInput from '../../inputs/customerTextInput/CustomerTextInput';
import CustomerFileInput from '../../inputs/customerFileInput/CustomerFileInput';
import CustomerRadioInput from '../../inputs/customerRadioInput/CustomerRadioInput';

function BookingInfoForm({ form }) {
  const { trans } = useTranslation();
  const { user } = useAuth();
  const { options } = useBooking();
  const vatIncluded = Form.useWatch('includingVat', form);

  useEffect(() => {
    form.setFieldsValue({ includingVat: true });
  }, []);

  return (
    <Form form={form} layout="vertical" className="flex flex-col gap-5">
      <div className="flex flex-col gap-3">
        <CustomerRadioInput
          name="paymentTypeId"
          groupClassName="flex lg:!flex-row gap-5 w-3/4"
          options={[{
            label: 'საბანკო გადარიცხვა',
            visible: true,
            className: 'flex-1',
            value: 3,
          },
          {
            label: 'ბარათით გადახდა',
            visible: true,
            className: 'flex-1',
            value: 5,
          }]}
          rules={[
            {
              required: true,
              message: trans('input_necessary'),
            },
          ]}
        />
        <div className="flex gap-5 lg:items-center lg:flex-row flex-col">
          <CustomerCheckInput name="includingVat" label={trans(vatIncluded ? 'including_vat' : 'vat_not_included')} defaultChecked />
          {
            !vatIncluded
            && (
            <div className="flex gap-5 items-center">
              <CustomerTextInput
                name="vatCode"
                label={trans('vat_code')}
                rules={[
                  {
                    required: true,
                    message: trans('input_necessary'),
                  },
                ]}
              />
              <CustomerFileInput
                name="vatFile"
                label={' '}
                form={form}
                rules={[
                  {
                    required: true,
                    message: trans('input_necessary'),
                  },
                ]}
                types={
                  [
                    'application/pdf',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  ]
              }
              />
            </div>
            )
          }
        </div>
        <h3 className="font-big-bold ">
          განმცხადებლის ინფორმაცია
        </h3>
        <div className="flex flex-col">
          {user?.type === 'physical'
                  && <PhysicalCustomerBookingInfo options={options} form={form} />}
          {user?.type === 'legal'
                  && <LegalCustomerBookingInfo options={options} form={form} />}
        </div>
      </div>

      <div className="w-full h-[1px] bg-gray-semi-light-gr" />

      <PersonInfo
        title="საკონტაქტო პირის ინფორმაცია"
        options={options}
        personType="contactPerson"
        form={form}
      />

      <div className="w-full h-[1px] bg-gray-semi-light-gr" />

      <PersonInfo
        title="ჯგუფის ხელმძღვანელის ინფორმაცია"
        options={options}
        personType="groupSupervisor"
        form={form}
        withIdNumber
      />
    </Form>
  );
}

export default BookingInfoForm;
